<template>
  <div class="product-list">
    <ul class="clearfix">
      <li v-for="(item, index) in list" :key="index">
        <div class="pic">
          <a @click="rowClick(item)" target="_blank">
            <img :src="item.picture | ''" alt="" class="p" />
          </a>
        </div>
        <div class="box">
          <div class="title">
            <a @click="rowClick(item)" target="_blank">{{ item.title }}</a>
          </div>
          <div class="item">
            挂牌价：
            <span class="fcdf2">
              <span class="">{{ item.priceFormat }}</span>
            </span>
          </div>
          <div class="item time">挂牌截止：{{ item.endDateFormat }}</div>
          <div class="item last">
            <span class="openTimes"><i></i> {{ item.click }} 次</span>
          </div>
          <a @click="rowClick(item)">
            <span v-if="item.ispllr == '1'" class="state-btn fr table-btn btn-bidding">
              详见公告
            </span>
            <template v-if="item.ispllr == '0'">
              <span
                v-if="item.statusName == '已重新挂牌'"
                class="state-btn fr table-btn btn-default"
              >
                已重新挂牌
              </span>
              <span
                v-if="item.statusName == '正在报名'"
                class="state-btn fr table-btn btn-enroll"
              >
                报名中
              </span>
              <span
                v-if="item.statusName == '正在报名|竞价中'"
                class="state-btn fr table-btn btn-enroll"
              >
                报名中
              </span>
              <span
                v-if="item.statusName == '项目终结'"
                class="state-btn fr table-btn btn-default"
              >
                项目终结
              </span>
              <span
                v-if="item.statusName == '项目中止'"
                class="state-btn fr table-btn btn-default"
              >
                项目中止
              </span>
              <span
                v-if="item.statusName == '竞价暂停'"
                class="state-btn fr table-btn btn-default"
              >
                竞价暂停
              </span>
              <span
                v-if="item.statusName == '竞价截止'"
                class="state-btn fr table-btn btn-default"
              >
                竞价截止
              </span>
              <span
                v-if="item.statusName == '未开始'"
                class="state-btn fr table-btn btn-default"
              >
                未开始
              </span>
              <span
                v-if="item.statusName == '报名截止'"
                class="state-btn fr table-btn btn-default"
              >
                报名截止
              </span>
              <span
                v-if="item.statusName == '竞价中'"
                class="state-btn fr table-btn btn-bidding"
              >
                竞价中
              </span>
              <span
                v-if="item.statusName == '已成交'"
                class="state-btn fr table-btn none btn-default"
              >
                已成交
              </span>
            </template>
          </a>
          <!-- 如果是灰色按钮，就去掉btn-bidding -->
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "ProductList",
  props: {
    list: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  methods: {
    rowClick(row) {
      if (row.noticeUrl) {
        window.open(row.noticeUrl, "_blank");
      } else {
        this.$router.push({
          name: "porpertyDetail",
          query: {
            id: row.infoId,
            tableType: 1,
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.product-list {
  width: 1200px;
  margin: 0px auto;
}
.product-list ul {
  padding: 0px 0px 0px;
  width: 103%;
  display: inline-block;
}
.product-list ul li {
  width: 285px;
  float: left;
  font-size: 14px;
  height: 338px;
  overflow: hidden;
  background: #fff;
  margin: 20px 20px 0px 0px;
  position: relative;
  border: 1px solid #ddd;
}

.product-list ul li .pic {
  width: 285px;
  height: 213px;
  position: relative;
}
.product-list ul li .pic .p {
  width: 285px;
  height: 213px;
  display: block;
  cursor: pointer;
}
.product-list ul li .pic a:hover .p {
  opacity: 0.9;
  filter: alpha(opacity=90);
}
.product-list ul li .pic:hover .p {
  opacity: 0.9;
  filter: alpha(opacity=90);
}
.product-list ul li .title {
  margin-top: 15px;
  padding: 0px 12px;
  line-height: 24px;
  height: 48px;
  overflow: hidden;
  cursor: pointer;
}
.product-list ul li .title a {
  color: #333;
}
.product-list ul li .title a:hover {
  color: #e15717;
}
.product-list ul li .item {
  line-height: 24px;
  margin-top: 2px;
  padding: 0px 12px;
  color: #666;
}
.product-list ul li .item.time {
  color: #999;
}
.product-list ul li .item.last {
  margin-top: 5px;
  height: 24px;
  overflow: hidden;
  padding-bottom: 12px;
}

.product-list ul li .item .openTimes {
  position: relative;
  padding-left: 25px;
  color: #999;
  line-height: 20px;
}
.product-list ul li .item .openTimes i {
  background: url(@/assets/images/hlj/base-ico.png) no-repeat;
  background-position: -60px -184px;
  width: 20px;
  height: 20px;
  position: absolute;
  left: 0px;
  top: 0px;
}
.product-list ul li .box {
  height: 125px;
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: 100%;
  transition: all ease 0.3s;
  background: #fff;
}
.product-list ul li:hover .box {
  height: 150px;
}
.product-list ul li .state-btn {
  opacity: 0;
  position: absolute;
  right: 10px;
  bottom: 5px;
  min-width: 60px;
  line-height: 30px;
  font-size: 14px;
  cursor: pointer;
}
.product-list ul li:hover .state-btn {
  opacity: 1;
  transition: all ease 0.3s;
}
.product-list ul li:hover .state-btn.btn-bidding {
  background: #e15717;
}
</style>
